'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("documentEcheanceService", function ($modal, $http, $dialogBox, $q) {
  var createPopinOptions = {
    controller: "DocumentsEcheanceEditionController",
    template: require("./documentsEcheanceEdition.html")
  };
  return {
    openPopin: function openPopin(produitId, echeance) {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {
          echeance: echeance,
          produitId: produitId
        },
        options: {
          width: 1200
        }
      }));
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/documents/documentEcheanceService.js
// module id = 2773
// module chunks = 13